import React from 'react';
import { commerceSecondaryLine } from '../../../../utils/commerceSearch';

/**
 * `formatOptionLabel` de react-select para opciones de comercio (ver `toCommerceOption`).
 *
 * La segunda línea (razón social · RUT) va SOLO en el menú (`context === 'menu'`): en el
 * control, el valor seleccionado en dos líneas rompe la altura del filtro.
 *
 * La segunda línea hereda el color de la opción con opacidad en vez de usar `text-fg-muted`:
 * la opción seleccionada del SearchableSelect se pinta `bg-brand-500 text-white`, y un gris
 * encima no se leería.
 */
export function formatCommerceOptionLabel(data, { context } = {}) {
  const secondary = context === 'menu' ? commerceSecondaryLine(data) : '';
  if (!secondary) return data.label;
  return (
    <span className="flex flex-col min-w-0">
      <span className="truncate">{data.label}</span>
      <span className="truncate text-xs opacity-75">{secondary}</span>
    </span>
  );
}

export default formatCommerceOptionLabel;
